import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { IndexWrapper, NativeContract, NativeSection, ServiceType } from "@framework/shared";

export const nativeRoutes: Array<RouteObject> = [
  {
    path: "/native",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="native">
            <NativeSection service={ServiceType.OFFICE} />
          </IndexWrapper>
        ),
      },
      {
        path: "/native/contracts",
        element: <Protected />,
        children: [
          { index: true, element: <NativeContract service={ServiceType.OFFICE} /> },
          { path: "/native/contracts/:id/:action", element: <NativeContract service={ServiceType.OFFICE} /> },
        ],
      },
    ],
  },
];
